import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DashboardModule } from './components/dashboard/dashboard.module';
import { SharedModule } from './shared/shared.module';
import { ProductsModule } from './components/products/products.module';
import { SalesModule } from './components/sales/sales.module';
import { CouponsModule } from './components/coupons/coupons.module';
import { PagesModule } from './components/pages/pages.module';
import { MediaModule } from './components/media/media.module';
import { MenusModule } from './components/menus/menus.module';
import { VendorsModule } from './components/vendors/vendors.module';
import { UsersModule } from './components/users/users.module';
import { LocalizationModule } from './components/localization/localization.module';
import { InvoiceModule } from './components/invoice/invoice.module';
import { SettingModule } from './components/setting/setting.module';;
import { ReportsModule } from './components/reports/reports.module';
import { AuthModule } from './components/auth/auth.module';
import { SectionModule } from './components/section/section.module';
import { PlacementsnewsModule } from './components/placementsnews/placementsnews.module';
import { NewsModule } from './components/news/news.module';
import { CourseModule } from './components/courses/course.module';
import { FeesModule } from './components/fees/fees.module';
import { CurriculumModule } from './components/curriculum/curriculum.module';
import { EligibilityModule } from './components/eligibility/eligibility.module';
import { MoredetailsModule } from './components/moredetails/moredetails.module';
import { PlacementsModule } from './components/placements/placements.module';
import { HomebannermenuModule } from './components/homebannermenu/homebannermenu.module';
import { AboutusOverviewModule } from './components/aboutus-overview/aboutus-overview.module';
import { RankingsModule } from './components/rankings/rankings.module';
import { LeadershipModule } from './components/leadership/leadership.module';
import { CommittesModule } from './components/committes/committes.module';
import { StudentstoriesModule } from './components/studentstories/studentstories.module';
import { CampusModule } from './components/campus/campus.module';
import { FacilitiesoverviewModule } from './components/facilitiesoverview/facilitiesoverview.module';
import { HomeRankSectionModule } from './components/homeranksection/homeranksection.module';
import { HkbkplacementsModule } from './components/hkbkplacements/hkbkplacements.module';
import { PlacementsOtherinfoModule } from './components/hkbkplacements-otherinfo/hkbkplacements-otherinfo.module';
import { PlacementsStudentsPlacedModule } from './components/hkbkplacements-students-placed/hkbkplacements-students-placed.module';
import { AcademicsModule } from './components/academics/academics.module';
import { FacultyModule } from './components/faculty/faculty.module';
import { AdvancedengineeringModule } from './components/advancedengineering/advancedengineering.module';
import { InstitutionsModule } from './components/institutions/institutions.module';

import { IqacHeadingModule } from './components/iqacheading/iqacheading.module';
import { IqacSubHeadingModule } from './components/iqac-subheading/iqac-subheading.module';
import { IqacContentModule } from './components/iqac-content/iqac-content.module';


import { InnovationHeadingModule } from './components/innovationheading/innovationheading.module';
import { InnovationSubHeadingModule } from './components/innovation-subheading/innovation-subheading.module';
import { InnovationContentModule } from './components/innovation-content/innovation-content.module';



import { IICModule } from './components/institute-industry-connect/institute-industry-connect.module';
import { FacilitiyModule } from './components/facility/facility.module';
import { LearningResourcesModule } from './components/learning-resources/learning-resources.module';
import { LearningResourcesUploadsModule } from './components/learning-resources-uploads/learning-resources-uploads.module';
import { FilespathModule } from './components/files-path/files-path.module';
import { HomeSliderModule } from './components/home-slider/home-slider.module';
import { InstitutionsSliderModule } from './components/institutions-slider/institutions-slider.module';
import { HowToApplyModule } from './components/how-to-apply/how-to-apply.module';
import { IndianStudentsModule } from './components/indian-students/indian-students.module';
import { NssModule } from './components/nss/nss.module';
import { InnovationModule } from './components/innovation/innovation.module';

import { SportsAdventureModule } from './components/sports-adventure/sports-adventure.module';
import { InternationalStudentsModule } from './components/international-students/international-students.module';
import { NewsYearModule } from './components/news-year/news-year.module';
import { TrainingVendorsModule } from './components/training-vendors/training-vendors.module';
import { PreplacementTrainingModule } from './components/preplacement-training/preplacement-training.module';
import { InstitutionsInfoModule } from './components/institutions-info/institutions-info.module';
import { NewsCategoriesModule } from './components/news-categories/news-categories.module';
import { TrainingDevelopmentModule } from './components/training-development/training-development.module';
import { TrainingDomainsContentModule } from './components/training-domains-content/training-domains-content.module';
import { TrainingDomainsHeadingModule } from './components/training-domains-heading/training-domains-heading.module';
import { LifehkbkoverviewModule } from './components/lifehkbkoverview/lifehkbkoverview.module';
import { GetMoreModule } from './components/get-more/get-more.module';
import { StudentlifeModule } from './components/studentlife/studentlife.module';
import { CurriculumEnhancementModule } from './components/curriculum-enhancement/curriculum-enhancement.module';
import { LecturesWorkshopsModule } from './components/lectures-workshops/lectures-workshops.module';
import { MentoringAdvisingModule } from './components/mentoring-advising/mentoring-advising.module';
import { StudentInnovationsModule } from './components/student-innovations/student-innovations.module';
import { ResearchHkbkModule } from './components/research-hkbk/research-hkbk.module';
import { HrDevelopmentModule } from './components/hr-development/hr-development.module';
import { SummerInternshipsModule } from './components/summer-internships/summer-internships.module';
import { SummerInternshipsHeadingModule } from './components/summer-internships-heading/summer-internships-heading.module';
import { BalanceSheetModule } from './components/balance-sheet/balance-sheet.module';
import { IndustryVisitsModule } from './components/industry-visits/industry-visits.module';
import { AdmissionsOverviewModule } from './components/admissions-overview/admissions-overview.module';
import { HumanResourcesModule } from './components/human-resources/human-resources.module';
import { FooterModule } from './components/footer/footer.module';
import { CoeModule } from './components/coe/coe.module';
import { BlogsModule } from './components/blogs/blogs.module';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';

import { fakeBackendProvider } from './_helper/fake-backend';
import { JwtInterceptor } from './_helper/jwt.interceptor';
import { ErrorInterceptor } from './_helper/error.interceptor';
import { HomeComponent } from './home/home.component';
import { AdminComponent } from './admin/admin.component';
import { LoginComponent } from './components/auth/login/login.component';
import { ClubsModule } from './components/clubs/clubs.module';
import { CareersModule } from './components/careers/careers.module';
import { EducationLoanModule } from './components/education-loan/education-loan.module';
import { ScholarshipsModule } from './components/scholarships/scholarships.module';
import { SeoCourcePageModule } from './components/seo-cource-page/seo-cources.module';
import { SeoCoursePageFaqModule } from './components/seo-course-page-faq/seo-course-page-faq.module';
import { BeyondModule } from './components/beyond/beyond.module';



const api_endpoint = 'https://orca-app-s7o8v.ondigitalocean.app/v1'; // https://hkbk.edu.in/backend/backend/v1

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AdminComponent,
    LoginComponent
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    HttpClientModule,
    AppRoutingModule,
    DashboardModule,
    SportsAdventureModule,
    InvoiceModule,
    SettingModule,
    ReportsModule,
    AuthModule,
    SharedModule,
    NssModule,
    InnovationModule,
    LocalizationModule,
    ProductsModule,
    SalesModule,
    VendorsModule,
    CouponsModule,
    PagesModule,
    MediaModule,
    MenusModule,
    UsersModule,
    SectionModule,
    PlacementsnewsModule,
    NewsModule,
    CourseModule,
    FeesModule,
    BeyondModule,
    CurriculumModule,
    EligibilityModule,
    MoredetailsModule,
    PlacementsModule,
    HomebannermenuModule,
    AboutusOverviewModule,
    RankingsModule,
    LeadershipModule,
    CommittesModule,
    StudentstoriesModule,
    CampusModule,
    FacilitiesoverviewModule,
    HomeRankSectionModule,
    HkbkplacementsModule,
    PlacementsOtherinfoModule,
    PlacementsStudentsPlacedModule,
    AcademicsModule,
    FacultyModule,
    AdvancedengineeringModule,
    InstitutionsModule,
    IqacHeadingModule,
    IqacSubHeadingModule,
    IqacContentModule,
    InnovationSubHeadingModule,
    InnovationHeadingModule,
    InnovationContentModule,
    IICModule,
    FacilitiyModule,
    LearningResourcesModule,
    LearningResourcesUploadsModule,
    FilespathModule,
    HomeSliderModule,
    InstitutionsSliderModule,
    HowToApplyModule,
    IndianStudentsModule,
    InternationalStudentsModule,
    NewsYearModule,
    TrainingVendorsModule,
    PreplacementTrainingModule,
    InstitutionsInfoModule,
    NewsCategoriesModule,
    TrainingDevelopmentModule,
    TrainingDomainsContentModule,
    TrainingDomainsHeadingModule,
    LifehkbkoverviewModule,
    GetMoreModule,
    StudentlifeModule,
    CurriculumEnhancementModule,
    LecturesWorkshopsModule,
    MentoringAdvisingModule,
    StudentInnovationsModule,
    CoeModule,
    BlogsModule,
    ResearchHkbkModule,
    HrDevelopmentModule,
    SummerInternshipsModule,
    SummerInternshipsHeadingModule,
    BalanceSheetModule,
    IndustryVisitsModule,
    AdmissionsOverviewModule,
    HumanResourcesModule,
    ClubsModule,
    FooterModule,
    CareersModule,
    EducationLoanModule,
    ScholarshipsModule,
    SeoCourcePageModule,
    SeoCoursePageFaqModule
  ],
  providers: [
    {provide: LocationStrategy, useClass: HashLocationStrategy},
    {provide: 'API_ENDPOINT', useValue: api_endpoint},
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },

    // provider used to create fake backend
    // fakeBackendProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
